<template>
  <div class="google-slides-container is-relative overflow-hidden">
    <GoogleSlideEmbedSkeleton :height="height" v-if="isLoading" />
    <iframe
      :src="embedUrl"
      class="is-absolute xy-t-0 xy-l-0 is-full-width is-full-height is-borderless"
      :class="classes"
      frameborder="0"
      :width="width"
      :height="height"
      allowfullscreen="false"
      mozallowfullscreen="false"
      webkitallowfullscreen="false"
      @load="onIframeLoad"
    ></iframe>
  </div>
</template>

<script>
import GoogleSlideEmbedSkeleton from '@/modules/embedurl/components/presentational/skeletons/GoogleSlideEmbedSkeleton.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'GoogleSlideEmbed',
  components: { GoogleSlideEmbedSkeleton },
  props: {
    value: {
      type: String
    },
    classes: {
      type: Array,
      default: () => []
    },
    width: {
      type: [Number, String],
      default: '100%'
    },
    height: {
      type: [Number, String],
      default: '300px'
    }
  },
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    embedUrl() {
      return `${this.value}?rm=minimal`;
    }
  },
  methods: {
    onIframeLoad() {
      setTimeout(() => {
        this.isLoading = false;
      }, 40);
    }
  }
};
</script>

<style scoped>
.google-slides-container {
  padding-bottom: var(--ce-aspect-ratio-16-9);
  height: 0;
}

.google-slides-container iframe {
  clip-path: inset(5px);
}
</style>
